// extracted by mini-css-extract-plugin
export default {"description":"TemplatePreviewAsModal_description__2ho7B"};